import React from "react";
import ModalV2 from "../../../../../../shared/components/modalV2";

function CaseFolderDetailsModal({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[400px]"
      edges="rounded-xl"
    >
      <div className="px-8 py-10 flex flex-col w-full items-center justify-center gap-y-3">
        <span className="text-2xl font-semibold">Case folder details</span>
        <div className="flex items-start w-full flex-col gap-y-0.5 border-b pb-3">
          <span className="text-sm font-normal">Case title</span>
          <span className="text-lg font-medium">Ogunlaji vs Adeyemi</span>
        </div>
        <div className="w-full flex flex-col gap-y-4 items-start">
          <span className="text-[16px] font-semibold">
            INFORMATION OF PARTIES
          </span>
          <span className="text-[16px] font-semibold">Plaintiff</span>
          <div className="w-full grid grid-cols-2 text-sm border-b pb-3">
            <div className="flex flex-col gap-y-3 items-start">
              <span className="font-normal text-black">Full name</span>
              <span className=" font-normal text-black">Email address</span>
              <span className="font-normal text-black">Phone number</span>
              <span className="font-normal text-black">Whatsapp number</span>
              <span className="font-normal text-black">Address</span>
            </div>
            <div className="flex flex-col gap-y-3 items-end text-sm ">
              <span className="font-normal text-black">Ogunlaji Ayaji</span>
              <span className=" font-normal text-black">
                {" "}
                Ogunlajia@gmail.com
              </span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">22 Kayode Street</span>
            </div>
          </div>
          <span className="text-[16px] font-semibold">Defendant</span>
          <div className="w-full grid grid-cols-2 text-sm border-b pb-3">
            <div className="flex flex-col gap-y-3 items-start">
              <span className="font-normal text-black">Full name</span>
              <span className=" font-normal text-black">Email address</span>
              <span className="font-normal text-black">Phone number</span>
              <span className="font-normal text-black">Whatsapp number</span>
              <span className="font-normal text-black">Address</span>
            </div>
            <div className="flex flex-col gap-y-3 items-end text-sm ">
              <span className="font-normal text-black">Ogunlaji Ayaji</span>
              <span className=" font-normal text-black">
                {" "}
                Ogunlajia@gmail.com
              </span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">22 Kayode Street</span>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-y-4 items-start">
          <span className="text-[16px] font-semibold">DETAILS OF COUNSEL</span>
          <span className="text-[16px] font-semibold">Plaintiff Counsel</span>
          <div className="w-full grid grid-cols-2 text-sm border-b pb-3">
            <div className="flex flex-col gap-y-3 items-start">
              <span className="font-normal text-black">Full name</span>
              <span className=" font-normal text-black">Email address</span>
              <span className="font-normal text-black">Phone number</span>
              <span className="font-normal text-black">Whatsapp number</span>
              <span className="font-normal text-black">Address</span>
            </div>
            <div className="flex flex-col gap-y-3 items-end text-sm ">
              <span className="font-normal text-black">Ogunlaji Ayaji</span>
              <span className=" font-normal text-black">
                {" "}
                Ogunlajia@gmail.com
              </span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">22 Kayode Street</span>
            </div>
          </div>
          <span className="text-[16px] font-semibold">Defendant Counsel</span>
          <div className="w-full grid grid-cols-2 text-sm border-b pb-3">
            <div className="flex flex-col gap-y-3 items-start">
              <span className="font-normal text-black">Full name</span>
              <span className=" font-normal text-black">Email address</span>
              <span className="font-normal text-black">Phone number</span>
              <span className="font-normal text-black">Whatsapp number</span>
              <span className="font-normal text-black">Address</span>
            </div>
            <div className="flex flex-col gap-y-3 items-end text-sm ">
              <span className="font-normal text-black">Ogunlaji Ayaji</span>
              <span className=" font-normal text-black">
                {" "}
                Ogunlajia@gmail.com
              </span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">080864343657</span>
              <span className="font-normal text-black">22 Kayode Street</span>
            </div>
          </div>
        </div>

        <button
          onClick={close}
          className="bg-[#009444] w-full text-white px-10 py-3 rounded-xl"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
}

export default CaseFolderDetailsModal;
